import React, { useState, useRef, useContext, useEffect } from "react";
import SharedModal from "../Shared/SharedModal";
import { Tooltip } from "antd";
import { Form as FormR } from "react-bootstrap";
import { Table, Form, Input } from "antd";
import { Button } from "react-bootstrap";

const VendorContacts = ({
  vendor,
  isOpen,
  handleUpdateContacts,
  handleAddContacts,
  handleDeleteContacts,
  handleSaveContacts,
  handleClearContacts,
  handleClose,
}) => {
  const EditableContext = React.createContext(null);
  const [isModalOpen, setIsModalOpen] = useState({ DeleteContacts: false });
  const [selectedContact, setSelectedContact] = useState();

  const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
      <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
          <tr {...props} />
        </EditableContext.Provider>
      </Form>
    );
  };

  const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
  }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
      if (editing) {
        inputRef.current.focus();
      }
    }, [editing]);
    const toggleEdit = () => {
      setEditing(!editing);
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    };
    const save = async () => {
      try {
        const values = await form.validateFields();
        toggleEdit();
        handleSave({
          ...record,
          ...values,
        });
      } catch (errInfo) {
        console.log("Save failed:", errInfo);
      }
    };
    let childNode = children;
    if (editable) {
      childNode = editing ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} is required.`,
            },
          ]}
        >
          <Input ref={inputRef} onPressEnter={save} onBlur={save} />
        </Form.Item>
      ) : (
        <div
          className="editable-cell-value-wrap"
          style={{
            paddingRight: 24,
          }}
          onClick={toggleEdit}
        >
          {children}
        </div>
      );
    }
    return <td {...restProps}>{childNode}</td>;
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const vendorContactDetailColumns = [
    {
      title: "Name",
      dataIndex: "VendorContactName",
      render: (text, record, index) => {
        let isValid = true;

        if (
          record.VendorContactName === "-" ||
          record.VendorContactName === ""
        ) {
          isValid = false;
        }

        return (
          <div style={{ display: "flex", position: "relative" }}>
            {!isValid && (
              <Tooltip
                title="Contact full name can't be '-' or empty."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="text"
              defaultValue={record.VendorContactName}
              onBlur={(e) =>
                handleUpdateContacts(e, record, "VendorContactName")
              }
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "Mobile Number",
      dataIndex: "VendorContactMobile",
      render: (text, record, index) => {
        let isValid = true;

        if (
          record.VendorContactMobile === "-" ||
          record.VendorContactMobile === ""
        ) {
          isValid = false;
        }

        return (
          <div style={{ display: "flex", position: "relative" }}>
            {!isValid && (
              <Tooltip
                title="Contact mobile can't be '-' or empty."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="text"
              defaultValue={record.VendorContactMobile}
              onBlur={(e) =>
                handleUpdateContacts(e, record, "VendorContactMobile")
              }
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "Email Address",
      dataIndex: "VendorContactEmail",
      render: (text, record, index) => {
        let isValid = true;

        if (
          record.VendorContactEmail === "-" ||
          record.VendorContactEmail === ""
        ) {
          isValid = false;
        }

        isValid =
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
            record.VendorContactEmail
          );

        return (
          <div style={{ display: "flex", position: "relative" }}>
            {!isValid && (
              <Tooltip
                title="Contact email address should be valid, and can't be '-' or empty."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="text"
              defaultValue={record.VendorContactEmail}
              onBlur={(e) =>
                handleUpdateContacts(e, record, "VendorContactEmail")
              }
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "Actions",
      render: (text, record, index) => (
        <img
          className="delete-icon"
          src={require("../../CustomerListView/delete.png")}
          onClick={() => handleDelete(record)}
          alt="Not Found!"
        />
      ),
    },
  ];

  const handleDelete = (record) => {
    setSelectedContact(record);
    setIsModalOpen({ DeleteContacts: true });
  };

  const handleConfirmDelete = () => {
    handleDeleteContacts(selectedContact);
  };

  const handleCloseDelete = () => {
    setIsModalOpen({ DeleteContacts: false });
  };

  return (
    <>
      {/*vendor delete modal */}
      <SharedModal
        isOpen={isModalOpen.DeleteContacts}
        title={"Delete Vendor Contact"}
        onDelete={handleConfirmDelete}
        onClose={handleCloseDelete}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div>
            <p className="p-main">
              Are you sure you want to delete the following additional contact?
              <br />
              This change can not be reversed.
            </p>
          </div>
          <div>
            <p className="p-main">{selectedContact?.VendorContactName}</p>
          </div>
        </div>
      </SharedModal>

      <SharedModal
        title={vendor.VendorName + "- Contacts"}
        isOpen={isOpen}
        onClose={handleClose}
        size={"lg"}
      >
        <div id="listview-body">
          <div className="col-12">
            <div id="home-table-container">
              <Table
                id="home-table"
                pagination={{
                  position: ["bottomCenter"],
                  showSizeChanger: true,
                  defaultPageSize: 5,
                  hideOnSinglePage: false,
                  pageSizeOptions: [5, 10, 20, 50, 100],
                }}
                bordered="true"
                components={components}
                columns={vendorContactDetailColumns}
                dataSource={vendor.VendorContactDetail}
                rowClassName="row-class-test"
                footer={() => (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Button onClick={handleAddContacts}>Add</Button>
                    <div style={{ display: "flex", gap: "20px" }}>
                      <Button
                        variant="danger"
                        onClick={() => handleClearContacts(vendor)}
                        style={{ alignSelf: "right" }}
                      >
                        Clear Changes
                      </Button>
                      <Button
                        variant="success"
                        onClick={handleSaveContacts}
                        style={{ alignSelf: "right" }}
                      >
                        Save Changes
                      </Button>
                    </div>
                  </div>
                )}
              ></Table>
            </div>
          </div>
        </div>
      </SharedModal>
    </>
  );
};

export default VendorContacts;
